import { post } from "./lib/api"

export function createSsoCallbackUrl(callbackUrl, urlOption, ssoOptions) {
  let ssoCallbackUrl = callbackUrl
  const params = $.param(
    Object.assign(
      urlOption || {},
      ssoOptions && { applet_id: ssoOptions.appletId },
      ssoOptions && { service_slug: ssoOptions.serviceSlug }
    )
  )
  if (params.length) {
    ssoCallbackUrl += (callbackUrl.includes("?") ? "&" : "?") + params
  }
  return ssoCallbackUrl
}

export async function appleSSO(
  callbackUrl,
  urlOption,
  ssoOptions,
  callbackOptions = {}
) {
  const ssoCallbackUrl = createSsoCallbackUrl(
    callbackUrl,
    urlOption,
    ssoOptions
  )

  try {
    const data = await AppleID.auth.signIn()
    return post(ssoCallbackUrl, { ...data.authorization, ...callbackOptions })
  } catch (error) {
    throw new Error("Your Apple ID authentication failed.")
  }
}

export function facebookSSO(
  callbackUrl,
  urlOption,
  ssoOptions,
  callbackOptions = { fbReauth: null }
) {
  const ssoCallbackUrl = createSsoCallbackUrl(
    callbackUrl,
    urlOption,
    ssoOptions
  )
  const opts = { scope: "email" }
  if (callbackOptions.fbReauth) {
    opts.auth_type = "rerequest"
  }
  delete callbackOptions.fbReauth

  return new Promise((resolve, reject) =>
    FB.login(function (response) {
      if (response.authResponse) {
        resolve(post(ssoCallbackUrl, callbackOptions))
      } else {
        const ssoErrorMessage = "Facebook could not verify your account."

        reject(new Error(ssoErrorMessage))
      }
    }, opts)
  )
}
